import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDEVuVAOegVe-dCz6pJ4bT7jwlS7Oj8_GU",
  authDomain: "cliniosglobal-d0866.firebaseapp.com",
  projectId: "cliniosglobal-d0866",
  storageBucket: "cliniosglobal-d0866.firebasestorage.app",
  messagingSenderId: "846198919507",
  appId: "1:846198919507:web:3c07580a5dd4641a7091a6",
  measurementId: "G-1MWVD6WEZT"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const firebaseConfigObject = { db };

export default firebaseConfigObject;
